

































import Vue, { PropType } from 'vue'
import BaseButton from '@/ui/button/BaseButton.vue'
import { $editedLessonId } from '@/pages/learning/learning-lessons/create/model/edit-lesson.model'
import { navigatePush } from '@/features/navigation/navigationMethods'
import { getStudentTokenFx } from '@/features/api/employee/getStudentToken'
import { getStudentToken } from '@/pages/users/students/edit/model/edit-student.model'
import Loader from '@/pages/common/parts/loader/Loader.vue'

export default Vue.extend({
  name: 'EditStudentFooter',
  components: {
    BaseButton,
    Loader,
  },
  props: {
    title: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: true },
    isPreview: { type: Boolean as PropType<boolean> },
  },
  effector: {
    lessonId: $editedLessonId,
    isLoading: getStudentTokenFx.pending,
  },
  methods: {
    goToList() {
      switch (this.$route.name) {
        default:
          navigatePush({ name: 'users-list' })
      }
    },
    onSaveClick() {
      this.$emit('save')
    },
    onSaveAndBackClick() {
      this.$emit('saveAndBackToList')
    },
    goToInterface() {
      getStudentToken()
    },
  },
})
